import "./MindMappingReportAHeader.css";

export default function MindMappingReportAHeader({toggle}) {
  return (
    <div className={toggle?"header-adjust":"mind-mapping-report-a-header-container"}>
      <div className="mind-mapping-report-a-header-card">
        <div className="mind-mapping-report-a-header-row">
          
          {/* LEFT COLUMN: Logo */}
          <div className="mind-mapping-report-a-header-left-col">
            <img 
              className="mind-mapping-report-a-header-logo" 
              src="/image/logo.png" 
              alt="Marsmate Logo" 
            />
          </div>

          {/* MIDDLE COLUMN: Title & Details */}
          <div className="mind-mapping-report-a-header-middle-col">
            <h1 className="mind-mapping-report-a-header-title">
              MARSMATE MIND MAPPING AUTOMATION ENGINE
            </h1>
            <div className="mind-mapping-report-a-header-details">
              <p>
                AI-driven visualization of skills, market gaps, sector focus,
                and execution-ready technologies
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}